export enum PaymentType {
  SessionFee = "Session Fee",
  Reuse = "Reuse",
  HoldingFee = "Holding Fee",
  Other = "Other",
}

export enum PerformerContractStatus {
  Draft = "draft",
  Pending = "pending",
  Sent = "sent",
  PerformerSigned = "performer_signed",
  ProducerSigned = "producer_signed",
  Completed = "completed",
  TimeLogApproved = "time_log_approved",
  Cancelled = "cancelled",
  Declined = "declined",
}

export enum PerformerOnboardingStatus {
  Cancelled = "cancelled",
  NotStarted = "not_started",
  Invited = "invited",
  InvitationAccepted = "invitation_accepted",
  Completed = "completed",
}

export enum PerformerContractType {
  Exhibit1 = "Exhibit1",
  Exhibit2 = "Exhibit2",
}
